var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VendorDetailLayout',{attrs:{"type":"suggestion","id":_vm.id,"listPage":"news","moduleName":"news","showDate":true,"showAddress":false,"showInformation":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }